(() => {
  function updateVariant(card, option) {
    if (!card || !option) return;

    const image = card.querySelector('[data-pc-image]');
    const current = card.querySelector('[data-pc-current]');
    const compare = card.querySelector('[data-pc-compare]');
    const price = card.querySelector('[data-pc-price]');
    const links = card.querySelectorAll('[data-pc-link]');
    const atcId = card.querySelector('[data-pc-atc-id]');
    const buy = card.querySelector('[data-pc-buy]');
    const coming = card.querySelector('[data-pc-coming]');
    const saleBadges = card.querySelectorAll('[data-pc-sale-badge], [data-pc-sale-price-badge]');
    const corner = card.querySelector('[data-pc-corner]');

    const isSale = option.dataset.sale === 'true';
    const isAvailable = option.dataset.available === 'true';
    const isComingSoon = card.dataset.comingSoon === 'true';
    const isPriceProtected = card.dataset.priceProtected === 'true';
    const isZeroPrice = option.dataset.zeroPrice === 'true';
    const releaseDate = option.dataset.releaseDate || card.dataset.releaseDate || 'Release date TBD';

    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.removeAttribute('srcset');
    }

    if (current) current.textContent = isZeroPrice ? releaseDate : (option.dataset.price || '');

    if (compare) {
      compare.textContent = isZeroPrice ? '' : (option.dataset.compare || '');
      compare.hidden = isZeroPrice || !isSale;
    }

    price?.classList.toggle('is-sale', isSale && !isZeroPrice);
    price?.classList.toggle('is-release-date', isZeroPrice);
    saleBadges.forEach((badge) => badge.hidden = isZeroPrice || !isSale);

    links.forEach((link) => {
      link.href = option.dataset.url || card.dataset.url;
    });

    if (atcId) atcId.value = option.value;

    if (coming) {
      coming.href = option.dataset.url || card.dataset.url;
      coming.hidden = !isComingSoon;
    }

    if (buy) {
      buy.href = option.dataset.url || card.dataset.url;
      buy.hidden = isComingSoon;
      buy.textContent = isAvailable
        ? (buy.dataset.defaultLabel || 'Add to cart')
        : 'Notify me on restock';
    }

    if (corner) {
      corner.hidden = isComingSoon
        ? false
        : (isAvailable ? !isPriceProtected : false);
    }

    card.classList.toggle('plug-card--coming-soon', isComingSoon);
    card.classList.toggle('plug-card--sold-out', !isAvailable && !isComingSoon);
  }

  function initVariants(section) {
    section.querySelectorAll('[data-pc-card]').forEach((card) => {
      const select = card.querySelector('[data-pc-variant-select]');

      if (select) {
        select.addEventListener('change', () => {
          updateVariant(card, select.options[select.selectedIndex]);
        });
      }

      card.querySelectorAll('[data-pc-variant]').forEach((input) => {
        input.addEventListener('change', () => updateVariant(card, input));
      });
    });
  }

  function initSort(section) {
    const sort = section.querySelector('[data-pc-sort]');
    sort?.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }

  function initFilters(section) {
    const filters = section.querySelector('[data-pc-filters]');
    const backdrop = section.querySelector('.plug-col__drawer-backdrop');
    const openButton = section.querySelector('[data-pc-filter-open]');
    if (!filters) return;

    const originalParent = filters.parentNode;
    const originalNext = filters.nextSibling;
    const backdropParent = backdrop?.parentNode || null;
    const backdropNext = backdrop?.nextSibling || null;

    const moveToBody = () => {
      if (window.matchMedia('(max-width: 989px)').matches) {
        if (filters.parentNode !== document.body) document.body.appendChild(filters);
        if (backdrop && backdrop.parentNode !== document.body) document.body.appendChild(backdrop);
      }
    };

    const restorePosition = () => {
      if (window.matchMedia('(min-width: 990px)').matches) {
        if (filters.parentNode !== originalParent) {
          originalParent.insertBefore(filters, originalNext);
        }
        if (backdrop && backdropParent && backdrop.parentNode !== backdropParent) {
          backdropParent.insertBefore(backdrop, backdropNext);
        }
      }
    };

    const open = () => {
      moveToBody();

      filters.classList.add('is-open');
      filters.setAttribute('aria-hidden', 'false');

      if (backdrop) {
        backdrop.hidden = false;
        backdrop.setAttribute('aria-hidden', 'false');
      }

      openButton?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('plug-col-lock');

      requestAnimationFrame(() => {
        filters.querySelector('[data-pc-filter-close]')?.focus();
      });
    };

    const close = () => {
      filters.classList.remove('is-open');
      filters.setAttribute('aria-hidden', 'true');

      if (backdrop) {
        backdrop.hidden = true;
        backdrop.setAttribute('aria-hidden', 'true');
      }

      openButton?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('plug-col-lock');
    };

    openButton?.addEventListener('click', open);
    filters.querySelectorAll('[data-pc-filter-close]').forEach((button) => {
      button.addEventListener('click', close);
    });
    backdrop?.addEventListener('click', close);

    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 990px)').matches) {
        close();
        restorePosition();
        filters.setAttribute('aria-hidden', 'false');
      } else {
        filters.setAttribute('aria-hidden', filters.classList.contains('is-open') ? 'false' : 'true');
      }
    }, { passive: true });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && filters.classList.contains('is-open')) {
        close();
      }
    });
  }

  function initViews(section) {
    const grid = section.querySelector('[data-pc-grid]');
    const buttons = [...section.querySelectorAll('[data-pc-view]')];
    if (!grid || !buttons.length) return;

    const storageKey = `plug-collection-view-${section.id}`;
    const configuredDefault = section.dataset.defaultView === 'list' ? 'list' : 'grid';
    let view = configuredDefault;

    try {
      const stored = localStorage.getItem(storageKey);
      if (stored === 'grid' || stored === 'list') view = stored;
    } catch (_) {}

    const apply = (nextView, save = true) => {
      const isList = nextView === 'list';
      grid.classList.toggle('is-list', isList);
      buttons.forEach((button) => {
        const active = button.dataset.pcView === (isList ? 'list' : 'grid');
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (save) {
        try {
          localStorage.setItem(storageKey, isList ? 'list' : 'grid');
        } catch (_) {}
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => apply(button.dataset.pcView === 'list' ? 'list' : 'grid'));
    });

    apply(view, false);
  }

  function initQuick(section) {
    const modal = section.querySelector('[data-pc-quick]');
    if (!modal || modal.dataset.pcQuickBound === 'true') return;
    modal.dataset.pcQuickBound = 'true';

    const image = modal.querySelector('[data-pc-quick-image]');
    const title = modal.querySelector('[data-pc-quick-title]');
    const variants = modal.querySelector('[data-pc-quick-variants]');
    const price = modal.querySelector('[data-pc-quick-price]');
    const link = modal.querySelector('[data-pc-quick-link]');
    let returnFocus = null;

    const moveToBody = () => {
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
    };

    const close = () => {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('plug-col-lock');
      returnFocus?.focus?.();
    };

    const render = (input) => {
      if (!input) return;
      const sale = input.dataset.sale === 'true';

      if (price) {
        price.classList.toggle('is-sale', sale);
        price.innerHTML = `${sale ? `<s>${input.dataset.compare || ''}</s>` : ''}<strong>${input.dataset.price || ''}</strong>`;
      }

      if (image && input.dataset.image) {
        image.src = input.dataset.image;
        image.removeAttribute('srcset');
      }

      if (link) link.href = input.dataset.url || '#';
    };

    const open = (button) => {
      const card = button.closest('[data-pc-card]');
      if (!card) return;

      returnFocus = button;
      moveToBody();

      const select = card.querySelector('[data-pc-variant-select]');
      const selected = select?.options[select.selectedIndex];
      const cardImage = card.querySelector('[data-pc-image]');

      if (title) title.textContent = card.dataset.title || '';
      if (image) {
        image.src = selected?.dataset.image || cardImage?.currentSrc || cardImage?.src || '';
        image.alt = card.dataset.title || '';
        image.removeAttribute('srcset');
      }
      if (link) link.href = selected?.dataset.url || card.dataset.url || '#';

      if (variants) {
        variants.innerHTML = '';
        if (select) {
          const label = document.createElement('label');
          label.className = 'plug-card__variant-select';
          label.innerHTML = '<span>Choose option</span>';

          const clone = select.cloneNode(true);
          clone.removeAttribute('id');
          clone.addEventListener('change', () => render(clone.options[clone.selectedIndex]));

          label.appendChild(clone);
          variants.appendChild(label);
          variants.hidden = false;
        } else {
          variants.hidden = true;
        }
      }

      if (selected) {
        render(selected);
      } else if (price) {
        const sourcePrice = card.querySelector('[data-pc-price]');
        price.innerHTML = sourcePrice?.innerHTML || '';
        price.classList.toggle('is-sale', sourcePrice?.classList.contains('is-sale'));
      }

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('plug-col-lock');

      requestAnimationFrame(() => {
        modal.querySelector('.plug-col__quick-close')?.focus();
      });
    };

    section.querySelectorAll('[data-pc-quick-open]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        open(button);
      });
    });

    modal.querySelectorAll('[data-pc-quick-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    modal.querySelector('.plug-col__quick-backdrop')?.addEventListener('click', close);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  }

  function initSection(section) {
    initVariants(section);
    initSort(section);
    initFilters(section);
    initViews(section);
    initQuick(section);
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-plug-collection]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();